import ssoMiddleware from 'modules/Common/middleware/ssoMiddleware';
import ApiClient from "utils/ApiClient";
import {createMetrics} from "react-metrics";
import getMetricsConfig from 'utils/metricsConfig';

export default function(config) {
    if (!global.window) {
        return [];
    }

    const client = new ApiClient();

    return ssoMiddleware(global.window, config, client, createMetrics, getMetricsConfig);
}


// WEBPACK FOOTER //
// ./modules/Common/middleware/ssoMiddlewareFactory.js